module.exports = __webpack_public_path__ + "src/assets/img/second_icon_1.2ff883e8.svg";